// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_n5-0";